<template>
  <div
    class="justopp-units-input flex width-expand padding-remove border-remove"
    :class="wrapperClass">
    <form-button
      :size="size"
      icon="minus"
      class="button-decrement control-button"
      :slim="true"
      :disabled="(value <= minimum ? true : false) || disabled"
      :show-slot="false"
      @click="decrement()"></form-button>

    <input
      v-model.number="value"
      :value="value"
      :disabled="disabled"
      v-bind="inputAttrs"
      class="input width-expand padding-m-horizontal text-center"
      @focusin="isFocused = true"
      @focusout="handleFocusOut" />

    <form-button
      class="button-increment control-button"
      :size="size"
      icon="plus"
      :slim="true"
      :disabled="(value >= maximum ? true : false) || disabled"
      :show-slot="false"
      @click="increment()"></form-button>
  </div>
</template>

<script>
import unitsInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/input/unitsInput.js";

export default {
  mixins: [unitsInputMixin],
  props: {
    stepSize: {
      type: Number,
      default: 50,
    },
    size: {
      type: String,
      default: "m",
    },
  },
  data: function () {
    return {};
  },
  computed: {
    value: {
      get() {
        if (isNaN(this.modelValue)) {
          return this.minimum;
        }

        return this.modelValue;
      },
      set(value) {
        if (parseInt(value) === this.maximum) {
          this.$emit("update:modelValue", parseInt(value));
          return true;
        }
        let lastValue = this.value;
        let lastStep = this.maximum;
        let nextToLastStep =
          this.maximum - this.stepSize - (this.maximum % this.stepSize);

        let direction = lastValue > value ? "down" : "up";

        if (this.isFocused) {
          this.$emit("update:modelValue", parseInt(value));
          return true;
        }

        // enforce minimum
        if (value < parseInt(this.minimum)) {
          this.$emit("update:modelValue", parseInt(this.minimum));
          this.value = parseInt(this.minimum);
          return true;
        }

        // enforce maximum
        if (value >= parseInt(this.maximum)) {
          this.$emit("update:modelValue", parseInt(this.maximum));
          this.value = parseInt(this.maximum);
          return true;
        }

        // snapping behaviour: snap to step
        // if value not moduleo 0 by step, and is not maximum, fall to closest step
        let rounded = Math.round(value / this.stepSize) * this.stepSize;
        let hasFullNextStep = value + this.stepSize <= this.maximum;

        // last step is larger. If we are going up, and there is no full step,
        // this is the last step. set to max
        if (direction === "up" && !hasFullNextStep) {
          this.$emit("update:modelValue", this.maximum);
          return true;
        }

        // last step is large. If we are going down, and "about to land" between
        // last and next to last steps, snap to second to last
        // i.e. maximum 330 step 50 target  290 -> 250, as last step is actually 80 (step + modulo to max)
        if (direction === "down" && rounded > nextToLastStep) {
          this.$emit("update:modelValue", nextToLastStep);
          return true;
        }

        // no special size. snap to nearst step
        this.$emit("update:modelValue", rounded);
      },
    },
    containerAttrs() {},
    wrapperClass() {
      let result = [""];
      result.push(this.class.replace("field__element", ""));
      return result;
    },
  },
  methods: {
    increment() {
      let newVal = +parseInt(this.value) + this.stepSize;

      if (newVal < this.maximum) {
        this.value = newVal;
      } else {
        this.value = this.maximum;
      }
    },
    decrement() {
      if (this.value > Number(this.minimum)) {
        this.value = +parseInt(this.value) - this.stepSize;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.input {
  border-top: 1px solid var(--c-gray-2);
  border-bottom: 1px solid var(--c-gray-2);
}
</style>
<style lang="scss">
.justopp-units-input {
  .button-decrement {
    [dir="ltr"] & {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    [dir="rtl"] & {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  .button-increment {
    [dir="ltr"] & {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    [dir="rtl"] & {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}
</style>
